export const queryKeys = {
  auth: {
    all: () => ["auth"] as const,
    profile: (uid: string) => [...queryKeys.auth.all(), "profile", uid] as const,
  },
  products: {
    all: () => ["products"] as const,
    userList: (userId: string, status?: string, name?: string) =>
      [...queryKeys.products.all(), "user", userId, { status, name }] as const,
    adminList: (status?: string, name?: string) =>
      [...queryKeys.products.all(), "admin", { status, name }] as const,
    detail: (uid: string) => [...queryKeys.products.all(), "detail", uid] as const,
  },
  media: {
    all: () => ["media"] as const,
    userList: (userId: string) => [...queryKeys.media.all(), "user", userId] as const,
    productList: (productId: string) => [...queryKeys.media.all(), "product", productId] as const,
  },
} as const;
